/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useAuth } from "../helper/auth";
import ScreenLoader from "../components/GeneralComponents/ScreenLoader";
import CustomTable from "../components/GeneralComponents/CustomTable";
import { NumericFormat } from "react-number-format";
import DeRegisterModal from "../components/GeneralComponents/DeRegisterModal";
import auth from "../api/auth";
import { onAPIError } from "../helper/functions";
import { Button } from "flowbite-react";
import RegisterMeterModal from "../components/GeneralComponents/RegisterMeterModal";
import { cubicMetres } from "../constants";

const cellClasses = "textpw-dark font-medium text-[17px]";

const columns = (onDeRegisterStart) => [
  {
    name: "Meter",
    selector: (row) => (
      <span className={cellClasses}>
        {row?.meter?.number}
        <br />
        <span className="text-[12px] pb-4">{row?.meter?.tenant?.name}</span>
      </span>
    ),
  },
  {
    name: "Balance",
    selector: (row) => (
      <NumericFormat
        thousandSeparator
        decimalScale={2}
        value={Number(row?.water_balance || 0)}
        suffix={` ${cubicMetres}`}
        className={cellClasses}
        displayType="text"
      />
    ),
  },
  {
    name: " ",
    selector: (row) => (
      <button
        onClick={() => onDeRegisterStart(row)}
        type="button"
        className="text-[red] font-semibold text-[17px]"
      >
        De-register
      </button>
    ),
  },
];

const ManageMeters = () => {
  const { getProfile, fetchingProfile, meterOwnerships, updateProfile } =
    useAuth();
  const [deregisterState, setDeRegisterState] = useState({
    visible: false,
    ownership: null,
    loading: false,
  });
  const [showRegisterModal, setShowRegisterModal] = useState(false);

  useEffect(() => {
    getProfile();
  }, []);

  const onDeRegisterStart = (meterOwnership) => {
    setDeRegisterState({
      visible: true,
      loading: false,
      ownership: meterOwnership,
    });
  };

  const onDeRegister = async (meterOwnershipId) => {
    setDeRegisterState((_) => ({ ..._, loading: true }));
    try {
      const { data } = await auth.deRegisterMeter({
        meter_ownership_id: meterOwnershipId,
      });
      setDeRegisterState((_) => ({ visible: false, loading: false }));
      updateProfile(data.data);
    } catch (e) {
      onAPIError(e);
      setDeRegisterState((_) => ({ ..._, loading: false }));
    }
  };

  if (fetchingProfile) {
    return <ScreenLoader />;
  }

  return (
    <div className="pt-10 w-full min-h-screen">
      <div className="py-3 flex items-center justify-between">
        <Button
          color="red"
          className="!bg-pw-blue ml-auto !text-white"
          onClick={() => setShowRegisterModal(true)}
        >
          {"Register New Meter"}
        </Button>
      </div>
      <div className="w-full">
        <CustomTable
          columns={columns(onDeRegisterStart)}
          data={meterOwnerships}
        />
      </div>
      <DeRegisterModal
        onClose={() =>
          setDeRegisterState((_) => ({ ..._, visible: false, loading: false }))
        }
        visible={deregisterState.visible}
        meterOwnership={deregisterState.ownership}
        onProceed={(meterOwnership) => {
          onDeRegister(meterOwnership.id);
        }}
        loading={deregisterState.loading}
      />
      <RegisterMeterModal
        visible={showRegisterModal}
        onClose={() => setShowRegisterModal(false)}
      />
    </div>
  );
};

export default ManageMeters;
